import React, { useEffect, useState } from "react";
import { apiCall_domain } from "../api";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import DetailsUserCar from "./DetailsUserCar";
import { Link } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import { makeStyles } from "@mui/styles";
import Radio from "@mui/material/Radio";
import List from "@mui/material/List";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import clsx from "clsx";
const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});
const classes = useStyles;
export default function SelectedUserCar() {
  // const [defaultValue, setDefaultValue] = useState();
  const [userCars, setUserCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [carName, setCarName] = useState("");
  const [carId, setCarId] = useState("");
  const [state, setState] = useState({});
  const fetchData = () => {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/user/cars`, {
        headers,
      })
      .then((res) => {
        setUserCars([...res.data.data]);
        if (res.data.data.length === 0) {
          localStorage.setItem("carId2", "");
          localStorage.setItem("carName", "");
        }
        setLoading(false);
        setCarId(localStorage.getItem("carId2"));
        setCarName(localStorage.getItem("carName"));
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const carChangeHandler = (e) => {
    setCarId(e.target.value);
    localStorage.setItem("carId2", e.target.value);
    let name = userCars.find((item) => {
      return item.id == e.target.value;
    }).name;
    setCarName(name);
    localStorage.setItem("carName", name);
  };


  const list = (anchor) => (
    <div className='selectedUserCarUI'>
      <div
        className={clsx(classes.list, {
          [classes.fullList]: anchor === "top" || anchor === "bottom",
        })}
        role='presentation'
        onClick={toggleDrawer(anchor, false)}
        onKeyDown={toggleDrawer(anchor, false)}>
        <List>
          <div className='userCarC'>
            <span className='UserCarTitleRe'>انتخاب خودرو</span>
          </div>
          <Link to='/carSelection/addUserCar'>
            <div className='addNewCar'>
              <img src='/public/assets/icons/plusInReminder.png' alt='pic' />
              <span className='text'>افزودن خودرو جدید</span>
            </div>
          </Link>
          <RadioGroup onClick={(e) => carChangeHandler(e)} value={+carId}>
            {userCars.map((item, i) => (
              <FormControlLabel
                key={i}
                value={+item.id}
                control={<Radio />}
                label={`${item.name}`}
              />
            ))}
          </RadioGroup>
        </List>
      </div>
    </div>
  );
  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          {["bottom"].map((anchor) => (
            <React.Fragment key={anchor}>
              <div className='selectedUserCarUI'>
                <div className='sort' onClick={toggleDrawer(anchor, true)}>
                  {localStorage.getItem("carId2") ? (
                    <>
                      <div className='chooseCar'>
                        <img
                          src='/public/assets/icons/car-CarSelection.svg'
                          alt='pic'
                        />
                        <span className='text'>
                          {carName === ""
                            ? localStorage.getItem("carName")
                            : carName}
                        </span>
                        <img
                          src='/public/assets/icons/carSelection_arrow.svg'
                          alt='pic'
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='chooseCar'>
                        <img
                          src='/public/assets/icons/car-CarSelection.svg'
                          alt='pic'
                        />
                        <span className='text'>
                          لطفا خودرو خود را انتخاب کنید
                        </span>
                        <img
                          src='/public/assets/icons/carSelection_arrow.svg'
                          alt='pic'
                        />
                      </div>
                      <div className='noCarSelectedSvg'>
                        <div>
                          <img
                            src='/public/assets/icons/noCarSelectedSvg.svg'
                            alt='pic'
                          />
                        </div>
                        <span>هنوز هیچ خودرویی انتخاب نشده</span>
                      </div>
                    </>
                  )}
                </div>
                {carId && <DetailsUserCar carId={carId} />}
                <Drawer
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}>
                  {list(anchor)}
                </Drawer>
              </div>
            </React.Fragment>
          ))}
        </>
      )}
    </>
  );
}
